export default "__VITE_ASSET__DLCrX57u__"